import { actionCreatorFactory } from "typescript-fsa";
import { ScreenSize } from "../utils/media";

const actionCreator = actionCreatorFactory("MEDIA");

export const screenSizeChanged = actionCreator<ScreenSize>("SCREEN_SIZE_CHANGED");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Media.ts